"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CasperLegacyWallet = void 0;
const legacy_wallet_1 = require("../../../wallet/legacywallet/legacy-wallet");
const casper_wallet_utils_1 = require("./casper-wallet-utils");
class CasperLegacyWallet extends legacy_wallet_1.LegacyWallet {
    /**
     * Get the public address of current wallet
     */
    getPublicKey() {
        return __awaiter(this, void 0, void 0, function* () {
            const publicKey = yield this.getRawPublicKey();
            return casper_wallet_utils_1.CasperWalletUtils.getPublicAddress(this.getEncryptionType(), publicKey);
        });
    }
}
exports.CasperLegacyWallet = CasperLegacyWallet;
